<template>
  <div class="header mb-5">
    <v-app-bar
      app
      :color="headerBg"
      flat
      height="65"
      :class="{ scroll: headerBg == 'white' }"
      class="appHeader"
    >
      <v-container class="py-0 align-center d-flex justify-space-between">
        <h1>seder</h1>
        <v-spacer></v-spacer>

        <v-btn
          fab
          depressed
          small
          class="transparent me-2"
          @click="openOrders"
        >
          <v-badge
            :value="$store.getters.notificationsNumber"
            color="red darken-1"
            left
            offset-y="10"
            overlap
          >
            <v-icon color="grey darken-1">mdi-bell</v-icon>
          </v-badge>
        </v-btn>

        <v-btn
          v-if="$store.getters.isSupp && !$route.meta.noMenu"
          @click="$store.state.drawer = !$store.state.drawer"
          class="me-3 white black--text"
        >
          <v-icon>menu</v-icon>
        </v-btn>
        <div v-if="$store.getters.isSupp" class="d-flex">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="white black--text" dark v-bind="attrs" v-on="on">
                {{ selectedLang }}
                <v-icon small class="ms-2">language</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click="selectLang(lang)"
                v-for="(lang, index) in $store.state.langs"
                :key="index"
              >
                <v-list-item-title>
                  {{ lang.name }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  data: () => ({
    headerBg: "transparent",
  }),

  computed: {
    selectedLang() {
      const selected = this.$store.getters.langs.find(
        (e) => e.locale == this.$store.state.def_locale
      );
      return selected ? selected.name : "...";
    },
  },
  methods: {
    logout() {
      let vm = this;
      this.$store.commit("logout");
      setTimeout(() => {
        vm.$router.push({ name: "login" });
      }, 500);
    },
    selectLang(lang) {
      document.cookie = `locale=${lang.locale}`;
      this.$store.state.def_locale = lang.locale;
      console.log(lang.locale);
    },
    openOrders() {
      this.$store.commit("resetNotification");
      if (this.$route.name != "ordersActivities") {
        this.$router.push("/ordersActivities");
      }
    },
  },
  created() {
    let app = this;
    window.addEventListener("scroll", function (e) {
      if (window.scrollY >= 20) {
        app.headerBg = "white";
      } else {
        app.headerBg = "transparent";
      }
    });
  },
};
</script>

<style lang="scss">
.appHeader.scroll {
  .v-toolbar__content {
    border-bottom: 2px solid #bd895b94;
  }
}
</style>
